import { render } from "./index.vue?vue&type=template&id=247c412c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=247c412c&lang=css"
import "./index.vue?vue&type=style&index=1&id=247c412c&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=2&id=247c412c&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247c412c"]])

export default __exports__